module.exports = __webpack_public_path__ + "/images/screen-vendedores-estrella.9da1be4.webp";